var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(" 区域代理的利润分成明细（D15）。代理分成按"),
            _c("b", [_vm._v("收货地")]),
            _vm._v(
              "判定，所以这里会出现别区团长带来的订单 —— 只要收货地在该代理辖区内，这笔分成就是他的。 代理端 app 里有同一份数据，两边口径一致，对账时不用换算。 "
            ),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "代理ID" } },
                [
                  _c("el-input", {
                    staticClass: "selWidthSm",
                    attrs: { clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.load(1)
                      },
                    },
                    model: {
                      value: _vm.query.agentId,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "agentId", _vm._n($$v))
                      },
                      expression: "query.agentId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "代理uid" } },
                [
                  _c("el-input", {
                    staticClass: "selWidthSm",
                    attrs: { clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.load(1)
                      },
                    },
                    model: {
                      value: _vm.query.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "uid", _vm._n($$v))
                      },
                      expression: "query.uid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "结算状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidthSm",
                      attrs: { clearable: "" },
                      on: {
                        change: function ($event) {
                          return _vm.load(1)
                        },
                      },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "待结算", value: 0 } }),
                      _c("el-option", {
                        attrs: { label: "到账等待期", value: 1 },
                      }),
                      _c("el-option", { attrs: { label: "可提现", value: 2 } }),
                      _c("el-option", { attrs: { label: "已失效", value: 3 } }),
                      _c("el-option", {
                        attrs: { label: "提现申请中", value: 4 },
                      }),
                      _c("el-option", { attrs: { label: "已提现", value: 5 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "省市区" } },
                [
                  _c("distribution-region-filter", {
                    model: {
                      value: _vm.query.regionPrefix,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "regionPrefix", $$v)
                      },
                      expression: "query.regionPrefix",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.load(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.list,
                size: "small",
                border: "",
                "show-summary": "",
                "summary-method": _vm.summary,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "订单号", "min-width": "170" },
              }),
              _c("el-table-column", {
                attrs: { label: "受益代理", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [_vm._v("uid " + _vm._s(row.uid))]),
                        _c("div", { staticClass: "sub-line" }, [
                          _vm._v("代理ID " + _vm._s(row.agentId)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "角色", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.roleText(row.commissionRole)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "省 / 市 / 区",
                  "min-width": "240",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.distributionRegionLabel(
                              row.regionCode,
                              row.regionName
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "实付款", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v("¥" + _vm._s(row.orderPrice))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "分成金额", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", { staticClass: "amount" }, [
                          _vm._v("¥" + _vm._s(row.commissionAmount)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusType(row.status),
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusText(row.status)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "产生时间",
                  "min-width": "150",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pager" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.query.size,
                  "current-page": _vm.query.page,
                  total: _vm.total,
                },
                on: { "size-change": _vm.onSize, "current-change": _vm.load },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }